import { FC } from 'react';

const Footer: FC = () => (
  <footer className="footer">
    &copy; {new Date().getFullYear()}  Hexact, Inc.
  </footer>
);

export default Footer;
